// extracted by mini-css-extract-plugin
export default {"horizontal":"wvfZI","large":"L6Y0v","vertical":"Ht+6m","bullet":"_4uUcm","a11y":"sBwR2","a11Y":"sBwR2"};